const logMiddleware = ({ getState, dispatch }) => (next) => (action) => {
  console.log(`Action: ${action.type}`)

  next(action)
}

export default logMiddleware



/** WEBPACK FOOTER **
 ** ./src/middleware/log.js
 **/